import { useState } from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import CloseIconExpForm from 'components/icon/close-icon-exp-form';

type FormPageProps = {
  className?: string;
  formContainerClassname?: string;
  title?: string;
  description?: string;
  notificationContent?: React.ReactNode;
  bottomContent?: React.ReactNode;
  formContent: React.ReactNode;
  children?: React.ReactNode;
};

export default function FormPage({ className, title, description, notificationContent, bottomContent, formContent, formContainerClassname }: FormPageProps) {
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  return (
    <div className={buildClassName(styles['container'], className)}>
      <div className={styles['content']}>
        <div className={styles['main-text']}>
          <h1 className={styles['title']}>{title}</h1>
          <p className={styles['description']}>
            {description}
          </p>
        </div>
        {isNotificationVisible && notificationContent && (
          <div className={buildClassName(styles['notification'])}>
            {notificationContent}
            <div className={styles['close-icon']} onClick={() => setIsNotificationVisible(false)}>
              <CloseIconExpForm/>
            </div>
          </div>
        )}
        <div className={buildClassName(styles['form-container'], formContainerClassname)}>
          {formContent}
        </div>
        {bottomContent && (
          <div className={styles['bottom-content']}>
            {bottomContent}
          </div>
        )}
      </div>
    </div>
  );
}